import * as React from 'react';
import * as moment from 'moment';

import DatePicker from './DatePicker';

import './agenda.less';

interface P {
    arrival?: moment.Moment;
    departure?: moment.Moment;
}

interface S {
    arrival?: moment.Moment;
    departure?: moment.Moment;
}

export default class Agenda extends React.Component<P, S> {

    static contextTypes: React.ValidationMap<any> = {
        router: React.PropTypes.object
    }

    context: { router: ReactRouter.InjectedRouter };

    constructor( props: P, context: any ) {
        super( props, context );

        this.state = {
            arrival   : this.props.arrival,
            departure : this.props.departure
        };
    }

    private setArrival( arrival: moment.Moment ) {
        this.setState({ arrival: arrival });

        if ( this.state.departure &&
             !this.state.departure.isAfter(arrival, 'day') )
            this.setState({ departure: moment( arrival ).add( 1, 'days' ) });
    }

    private setDeparture( departure: moment.Moment ) {
        this.setState({ departure: departure });

        if ( this.state.arrival &&
             !this.state.arrival.isBefore(departure, 'day') ) {
            var arrival = moment( departure );
            arrival.subtract( 1, 'days' );

            this.setState({ arrival: arrival });
        }
    }

    private check() {
        if ( this.state.arrival && this.state.departure ) {
            let arrival = this.state.arrival.format('YYYY-MM-DD'),
                departure = this.state.departure.format('YYYY-MM-DD');

            this.context.router.push( `/booking/from/${arrival}/thru/${departure}` );
        }
    }

    render(): null {
        return null;
    }

    _render() {
        let today = moment();
        let tomorrow = moment( today ).add( 1, 'days' );

        return (
            <div className="agenda component">
              <div className="row">
                <div className="six wide centered column">
                  <DatePicker name="arrival"
                              value={ this.state.arrival }
                              placeholder="Arrival"
                              onChange={ date => this.setArrival(date) }
                              today={ today }
                              epoch={ today } />
                  <DatePicker name="departure"
                              value={ this.state.departure }
                              placeholder="Departure"
                              onChange={ date => this.setDeparture(date) }
                              today={ today }
                              epoch={ tomorrow } />
                  <button type="submit"
                          onClick={ () => this.check() }>
                    Check availability
                  </button>
                </div>
              </div>
            </div>
        );
    }

}



/** WEBPACK FOOTER **
 ** ./src/components/widgets/Agenda.tsx
 **/